module.exports = __webpack_public_path__ + "img/logo.e09aaf9e.png";